export default "__VITE_ASSET__D43xP38N__"